import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { globalDefines } from '../../app/app.constants';
import { FraudProvider } from '../../providers/fraud/fraud';


@IonicPage()
@Component({
  selector: 'page-frauds',
  templateUrl: 'frauds.html',
})
export class FraudsPage {

  checks = [];
  private checksSubscription;
  private limitScroll;

  constructor(
    public alertCtrl: AlertController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public fraudProvider: FraudProvider,
  ) {;
    this.limitScroll = globalDefines.limitScrollOriginal;

    this.loadChecks(this.limitScroll);
  }

  ionViewWillUnload() {
    if(this.checksSubscription && !this.checksSubscription.closed) this.checksSubscription.unsubscribe();
  }

  doInfinite(infiniteScroll) {
    setTimeout(() => {
      this.limitScroll += globalDefines.limitScrollOriginal;
      this.loadChecks(this.limitScroll);

      infiniteScroll.complete();
    }, 500);
  }

  loadChecks(limitScroll) {
    if(this.checksSubscription && !this.checksSubscription.closed) this.checksSubscription.unsubscribe();

    this.checksSubscription = this.fraudProvider.getLastFrauds(limitScroll).subscribe(checks => {
      this.checks = checks;
    });
  }

  remove(check) {
    let confirm = this.alertCtrl.create({
      title: 'Eliminar un fraude',
      message: '¿Seguro que quiere eliminarlo?',
      buttons: [
        {
          text: 'No',
          handler: () => {}
        },
        {
          text: 'Sí',
          handler: () => {
            this.fraudProvider.remove(check.key).then(() => {
              this.showMessage('Fraude eliminado')
            });
          }
        }
      ]
    });
    confirm.present();
  }
  ubication(check) {
    if(check.coords) {
      this.navCtrl.push('MapPage', { mode: 'check', check: check });
    }

    else this.showMessage(`Este fraude hace referencia a un fichaje que se ha añadido manualmente o mediante de un fichador.`);
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/frauds/frauds.ts